import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

const label = 'selectForSend';

async function handler(apiOptions, actions) {
  const { getSelectedResources, selectFilesToSend } = actions;

  selectFilesToSend(getSelectedResources());
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;
  return {
    id: label,
    icon: { icon: icons.send },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const selectedResources = getSelectedResources();

      return (
        selectedResources.length > 0 && !selectedResources.some((r) => r.type === 'dir') && selectedResources.every((r) => r.capabilities.canDownload)
      );
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
